import React from 'react';


function A8Oisix() {
    return (
        <div>
            <p>PR: Oisixのおためしセットはいかが? デキるビジネスマンとして「買物時間の削減」と「健康」にも投資してみませんか? </p>
            <a href="https://px.a8.net/svt/ejp?a8mat=3Z0GJU+2OGABM+3RK+2TV9LT" rel="nofollow">
                {/* @ts-ignore */}
                <img border="0" width="200" height="200" alt="" src="https://www25.a8.net/svt/bgt?aid=240206538162&wid=003&eno=01&mid=s00000000488017110000&mc=1" />
            </a>
            {/* @ts-ignore */}
            <img border="0" width="1" height="1" src="https://www10.a8.net/0.gif?a8mat=3Z0GJU+2OGABM+3RK+2TV9LT" alt="" />
        </div>
    );
}

export default A8Oisix;
